<template>
  <sticky-header-layout>
    <template #header>
      <list-page-header>
        <div slot="right">
          <el-button
            :disabled="isSaving"
            size="mini"
            type="primary"
            icon="el-icon-back"
            @click="handleCancel"
          >
            {{ $t('button.back') }}
          </el-button>
          
          <el-button
            :disabled="isLoadingClient"
            :loading="isSaving"
            size="mini"
            type="danger"
            icon="el-icon-upload2"
            @click="handleSave"
          >
            {{ $t('button.save') }}
          </el-button>
        </div>
      </list-page-header>
    </template>

    <div v-loading="isLoadingClient">
      <el-form
        v-loading="isLoadingClient"
        ref="form"
        :disabled="isSaving"
        :model="form"
        :rules="formRules"
        class="round-border-form"
        label-position="top"
        label-width="200"
      >
        <h4 class="title">Client Detail</h4>

        <div class="form-group">
          <el-form-item
            label="Name"
            prop="name"
          >
            <el-input v-model="form.name" />
          </el-form-item>
        </div>
        
        <div class="form-group">
          <el-form-item
            label="Phone"
            prop="phone"
          >
            <el-input v-model="form.phone" />
          </el-form-item>
        </div>

        <div class="form-group">
          <el-form-item
            label="Email"
            prop="email"
          >
            <el-input v-model="form.email" />
          </el-form-item>
        </div>
      </el-form>
    </div>

    <div 
      v-if="isEditMode"
      v-loading="isLoadingProfileList"
    >
      <h4 class="title">Profile List</h4>

      <div style="float:right;margin-bottom:10px;">
        <el-button
          class="add-button"
          type="primary"
          icon="el-icon-edit"
          @click="handleCreateProfile"
        >
          {{ $t('button.create') }}
        </el-button>
      </div>

      <el-table
        v-loading="isLoadingProfileList"
        :data="profileList"
        border
      >
        <el-table-column
          label="Name"
          prop="name"
          width="200"
        />

        <el-table-column
          label="Gender"
          prop="gender"
          width="80"
        />

        <el-table-column
          label="Birthday"
          prop="birthday"
          width="100"
        />

        <el-table-column
          label="Top"
          prop="top_size"
          width="60"
        />

        <el-table-column
          label="Bottom"
          prop="bottom_size"
          width="80"
        />

        <el-table-column
          label="Shoes"
          prop="shoes_size"
          width="60"
        />

        <el-table-column
          label="Remarks"
          prop="remarks"
        />

        <el-table-column
          fixed="right"
          label="Action"
          align="center"
          width="100"
        >
          <template slot-scope="{ row }">
            <el-button
              size="mini"
              type="warning"
              icon="el-icon-edit"
              circle
              @click="handleUpdateProfile(row)"
            />
          </template>
        </el-table-column>
      </el-table>
    </div>

    <div 
      v-if="isEditMode"
      v-loading="isLoadingAddressList"
    >
      <h4 class="title">Address List</h4>

      <div style="float:right;margin-bottom:10px;">
        <el-button
          class="add-button"
          type="primary"
          icon="el-icon-edit"
          @click="handleCreateAddress"
        >
          {{ $t('button.create') }}
        </el-button>
      </div>

      <el-table
        v-loading="isLoadingAddressList"
        :data="addressList"
        border
      >
        <el-table-column
          label="Address Nickname"
          prop="nickname"
          width="150"
        />

        <el-table-column
          label="Name"
          prop="name"
          width="150"
        />

        <el-table-column
          label="Address"
          prop="address"
        />

        <el-table-column
          label="Phone"
          prop="phone"
          width="120"
        />

        <el-table-column
          label="Remarks"
          prop="remarks"
          width="200"
        />

        <el-table-column
          label="Default?"
          prop="is_default"
          align="center"
          width="80"
        >
          <template slot-scope="{ row }">
            <div style="display:flex;justify-content:center;">
              <el-tag
                v-if="row.is_default"
                type="success"
              >
                Yes
              </el-tag>

              <el-tag
                v-else
                type="danger"
              >
                No
              </el-tag>
            </div>
          </template>
        </el-table-column>

        <el-table-column
          fixed="right"
          label="Action"
          align="center"
          width="100"
        >
          <template slot-scope="{ row }">
            <el-button
              size="mini"
              type="warning"
              icon="el-icon-edit"
              circle
              @click="handleUpdateAddress(row)"
            />
          </template>
        </el-table-column>
      </el-table>
    </div>

    <div 
      v-if="isEditMode"
      v-loading="isLoadingOrderItemList"
    >
      <h4 class="title">Order Item List</h4>

      <el-table
        v-loading="isLoadingOrderItemList"
        :data="orderItemList"
        border
      >
        <el-table-column
          label="Order Number"
          prop="order_number"
          width="120"
        />

        <el-table-column
          label="Order Date"
          prop="order_date"
          width="100"
        />

        <el-table-column
          label="Item Brand"
          prop="item_brand"
          width="160"
        />

        <el-table-column
          label="Item Name"
          prop="item_name"
        />

        <el-table-column
          label="Quantity"
          prop="quantity"
          width="80"
        />

        <el-table-column
          label="Currency"
          prop="currency"
          width="80"
        />

        <el-table-column
          label="Unit Price"
          prop="unit_price"
          width="100"
        />
      </el-table>
    </div>

    <div 
      v-if="isEditMode"
      v-loading="isLoadingLikedProductList"
    >
      <h4 class="title">Liked Product List</h4>

      <div>
        <div 
          v-for="product in likedProductList"
          class="product-cell"
        >
          <img :src="product.main_image_mobile" />
          <div class="product-brand"><b>{{ product.brand_name }}</b></div>
          <div class="product-name">{{ product.name }}</div>
        </div>
      </div>
    </div>
  </sticky-header-layout>
</template>

<script>
import { createComponent, computed, reactive, ref, watch, onBeforeMount } from '@vue/composition-api'
import ListPageHeader from '@/views/layout/components/ListPageHeader.vue'

import PrivateClientsService from '../../api/private-clients'
import { i18n } from '@/lang'

const PrivateClientDetail = createComponent({
  name: 'PrivateClientDetail',
  components: {
    ListPageHeader,
  },
  props: {
    id: {
      type: [String, Number],
      default: undefined,
    },
  },
  setup({ id }, { root, refs }) {
    const { $router } = root

    const isLoadingClient = ref(false)

    const isLoadingProfileList = ref(false)
    const isLoadingAddressList = ref(false)
    const isLoadingOrderItemList = ref(false)
    const isLoadingLikedProductList = ref(false)
    const isSaving = ref(false)
    const isEditMode = ref(false)

    const profileList = ref([])
    const addressList = ref([])
    const orderItemList = ref([])
    const likedProductList = ref([])

    const form = reactive({
      name: null,
      phone: null,
      email: null,
    })

    const formRules = reactive({
      name: [{ required: true, message: i18n.t('error.thisFieldIsRequired'), trigger: 'blur' }],
    })

    const goToListPage = () => {
      $router.push({ path: '/private-client/client/list' })
    }

    const goToEditPage = () => {
      $router.push({ path: '/private-client/client/list' })
    }

    const handleSaveSuccess = (itemId) => {
      isSaving.value = false

      root.$alert('The record has been saved.', 'Success', {
        confirmButtonText: root.$t('button.ok'),
      }).then(() => {
        if (itemId) {
          $router.push({ path: `/private-client/client/edit/${itemId}` })
        }
      })
    }

    const handleSaveFail = (error) => {
      isSaving.value = false

      root.$alert(`Error: ${error}`, root.$t('error.somethingWentWrong'), {
        type: 'error',
        confirmButtonText: root.$t('button.ok'),
      })
    }

    onBeforeMount(async () => {
      if (id) {
        isEditMode.value = true
        getDetail(id)
      }
    })

    const getDetail = async (id) => {
      isLoadingClient.value = true

      try {
        const { data } = await PrivateClientsService.getClient(id)
        
        Object.keys(data).forEach((key) => {
          if (key === 'type' && !data[key]) return
          form[key] = data[key]
        })

        getProfileList()
        getAddressList()
        getOrderItemList()
        getLikedProductList()
      } catch (error) {
        root.$alert(root.$t('error.recordNotFound'), root.$t('button.error'), {
          confirmButtonText: root.$t('button.ok'),
          type: 'error',
        }).then(() => {
          goToListPage()
        })
      } finally {
        isLoadingClient.value = false
      }
    }

    const getProfileList = async () => {
      isLoadingProfileList.value = true

      const { data } = await PrivateClientsService.getProfileList(id)

      isLoadingProfileList.value = false

      profileList.value = data
    }

    const getAddressList = async () => {
      isLoadingAddressList.value = true

      const { data } = await PrivateClientsService.getAddressList(id)

      isLoadingAddressList.value = false

      addressList.value = data
    }

    const getOrderItemList = async () => {
      isLoadingOrderItemList.value = true

      const { data } = await PrivateClientsService.getOrderItemList(id)

      isLoadingOrderItemList.value = false

      orderItemList.value = data
    }

    const getLikedProductList = async () => {
      isLoadingLikedProductList.value = true

      const { data } = await PrivateClientsService.getLikedProductList(id)

      isLoadingLikedProductList.value = false

      likedProductList.value = data
    }

    const save = async (form) => {
      isSaving.value = true

      if (id) {
        try {
          await PrivateClientsService.editClient(id, form)
          handleSaveSuccess()
        } catch (error) {
          handleSaveFail(error)
        }
      } else {
        try {
          const { data } = await PrivateClientsService.createClient(form)

          handleSaveSuccess(data.id)
        } catch (error) {
          handleSaveFail(error)
        }
      }
    }

    const handleCancel = () => goToListPage()

    const handleSave = () => {
      refs.form.validate().then(() => {
        save(form)
      }).catch((error) => {
        root.$alert(root.$t('error.pleaseFillInAndCheckErrors'), root.$t('common.oops'), {
          confirmButtonText: root.$t('button.ok'),
        })
      })
    }

    const handleCreateProfile = () => {
      $router.push({ path: `/private-client/client/${id}/profile/create` })
    }

    const handleUpdateProfile = (item) => {
      $router.push({ path: `/private-client/client/${id}/profile/edit/${item.id}` })
    }

    const handleCreateAddress = () => {
      $router.push({ path: `/private-client/client/${id}/address/create` })
    }

    const handleUpdateAddress = (item) => {
      $router.push({ path: `/private-client/client/${id}/address/edit/${item.id}` })
    }

    return {
      form,
      formRules,
      profileList,
      addressList,
      orderItemList,
      likedProductList,
      handleCancel,
      handleSave,
      handleCreateProfile,
      handleUpdateProfile,
      handleCreateAddress,
      handleUpdateAddress,
      isLoadingClient,
      isLoadingProfileList,
      isLoadingAddressList,
      isLoadingOrderItemList,
      isLoadingLikedProductList,
      isSaving,
      isEditMode,
    }
  },
})

export default PrivateClientDetail
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/view-base.scss";
@import "~@/assets/styles/form.scss";

.product-cell {
  float: left;
  width: 150px;
  height: 250px;
}

.product-cell img {
  width: 120px;
}

.product-brand, .product-name {
  font-size: 12px;
}

</style>
